import { CustomJrpcErrResult } from '../jsonRpc/jRpcErrResponse';
import { getHubApi } from '../accountServiceApi/getAccountServiceApi';
import { RpcReceivedError } from '@scorewarrior/rubens_web_lib/lib/errors/rpc-received-error';

export type ConfirmEmailOtpAuthRequest = {
    email: string,
    otp: string,
    locale: string
    current_entry_point: string
}

export type ConfirmEmailOtpAuthResponse = {
    tether: {
        suid: string;
        token: string;
    };
};

export async function confirmEmailOtpAuth(
    data: ConfirmEmailOtpAuthRequest
): Promise<ConfirmEmailOtpAuthResponse | CustomJrpcErrResult> {
    const hubApi = getHubApi();
    try {
        return await hubApi.confirmEmailOtpAuth(window.app.deviceIdentifier, data) as ConfirmEmailOtpAuthResponse;
    } catch (error) {
        // The hub client throws on an error response; the form after-handler expects it as a result.
        if (error instanceof RpcReceivedError) {
            return { error: { code: error.code, data: error.data, message: error.message } };
        }
        throw error;
    }
}
